import React, { useState, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Button, FormControl, Row, Col, Form, Modal } from "react-bootstrap";
import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { decryptId } from "../../utils/helpers";
const API_URL = process.env.REACT_APP_API_URL;
const FILE_BASE_URL = process.env.REACT_APP_API_URL.replace("/api", "");

function DFIDataSCDKit() {


    const { sample_id } = useParams();


    const decodedId = decodeURIComponent(sample_id);
    const id_sample = decryptId(decodedId);
    const alertShown = useRef(false);


    const [autoSaveAfterDelete, setAutoSaveAfterDelete] = useState(false);

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [deletedDocs, setDeletedDocs] = useState([]);

    const [values, setValues] = useState({
        sample_id: "",
        kit_id: "",
        large_halo: "",
        medium_halo: "",
        small_halo: "",
        no_halo: "",
        degraded: "",
        total: "",
        non_fragmented: "",
        fragmented: "",
        DNA_index: "",
        remark: ""

    });

    const { user } = useAuth();
    ///////////////////////////
    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [error, setError] = useState("");
    ////////////////////////////


    const [documents, setDocuments] = useState([{ id: Date.now(), name: "Halo images", file: null }]);
    const addRow = () => {
        setDocuments([...documents, { id: Date.now(), name: "Halo images", file: null }]);
    };
    // const removeRow = (id) => {
    //     if (documents.length === 1) return;
    //     setDocuments(documents.filter((doc) => doc.id !== id));
    // };
    const removeRow = (id) => {
        if (documents.length === 0) return;

        const confirmDelete = window.confirm("Do you want to delete?");

        const doc = documents.find(d => d.id === id);

        // if document already exists in DB, mark for deletion
        if (confirmDelete) {
            if (doc?.existing) {
                setDeletedDocs(prev => [...prev, doc.id]);
            }
        }

        setDocuments(documents.filter(d => d.id !== id));
    };

    const handleNameChange = (id, value) => {
        setDocuments(
            documents.map((doc) => (doc.id === id ? { ...doc, name: value } : doc))
        );
    };

    const handleFileChange = (id, file) => {
        setDocuments(
            documents.map((doc) => (doc.id === id ? { ...doc, file: file } : doc))
        );
    };

    const inputStyle = {
        width: "150px",
        padding: "6px 12px",
        height: "35px",
        border: "2px solid #001A43",
        borderRadius: "6px",
        margin: "6px 0"
    };

    const labelStyle = {
        backgroundColor: "#DFF5F1",
        width: "200px",
        padding: "6px 12px",
        margin: "6px 0",
        borderRadius: "6px",
        border: "1px solid #4DB6AC",
        textAlign: "center"
    };


    const handleChange = (field, value) => {
        const updated = { ...values, [field]: value };

        const L = Number(updated.large_halo || 0);
        const M = Number(updated.medium_halo || 0);
        const S = Number(updated.small_halo || 0);
        const N = Number(updated.no_halo || 0);
        const D = Number(updated.degraded || 0);

        const total = L + M + S + N + D;
        const nonFrag = L + M;
        const frag = S + N + D;
        const dfi = total > 0 ? ((frag / total) * 100).toFixed(2) : "";

        updated.total = total;
        updated.non_fragmented = nonFrag;
        updated.fragmented = frag;
        updated.DNA_index = dfi;

        setValues(updated);
    };

    const fieldMap = {
        "Large Halo": "large_halo",
        "Medium Halo": "medium_halo",
        "Small Halo": "small_halo",
        "No Halo": "no_halo",
        "Degraded": "degraded"
    };

    useEffect(() => {
        if (!id_sample) return;

        axios.get(`${API_URL}/dfi-data/${id_sample}`)
            .then(res => {
                if (res.data.status) {
                    setValues(res.data.data);

                    // Load existing attachments
                    if (res.data.attachments?.length) {
                        setDocuments(
                            res.data.attachments.map(att => ({
                                id: att.att_id,
                                name: att.doc_name,
                                file: null,
                                existing: true,
                                file_path: att.file_path
                            }))
                        );
                    }
                }
            })
            .catch(err => {
                console.error(err);
                setErrorMsg("Failed to load DFI data");
            });
    }, [id_sample]);



    const handleSave = async () => {
        try {
            const formData = new FormData();

            Object.entries(values).forEach(([k, v]) => {
                formData.append(k, v ?? "");
            });

            documents.forEach((doc, i) => {
                if (doc.file) {
                    formData.append(`documents[${i}][file]`, doc.file);
                    formData.append(`documents[${i}][name]`, doc.name);
                }
            });
            deletedDocs.forEach(id => {
                formData.append("deleted_docs[]", id);
            });
            const res = await axios.post(
                `${API_URL}/dfi-scd-kit-update/${values.kit_id}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            // setSuccessMsg(res.data.message); 
            // alert(res.data.message || "Saved successfully");
            // setErrorMsg("");
            setSuccessMsg(
                res.data.message || `DFI data - SCD kit data saved successfully`
            ); setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);
        } catch (err) {
            console.error(err);
            setErrorMsg("Save failed");
        }
    };


    const openPasswordModal = (literature_id) => {
        setSelectedId(literature_id);
        setPassword("");
        setError("");
        setShowModal(true);
    };


    const verifyPassword = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/verify-password`,
                { password, uid: user?.uid },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (res.data.success) {
                setShowModal(false);

                removeRow(selectedId);
                setAutoSaveAfterDelete(true);
            } else {
                setError("Incorrect password");
            }
        } catch (err) {
            setError("Incorrect password");
        }
    };
    useEffect(() => {
        if (autoSaveAfterDelete) {
            const fakeEvent = { preventDefault: () => { } };
            handleSave(fakeEvent);   // call API
            setAutoSaveAfterDelete(false);
        }
    }, [documents]);
    return (
        <div style={{ padding: "30px" }}>
            <h6 style={{ textAlign: "left" }}>DFI data - SCD kit</h6>

            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "40px",
                    marginTop: "30px"
                }}
            >
                <div>
                    {["Large Halo", "Medium Halo", "Small Halo", "No Halo", "Degraded", "Total"].map(
                        (label, idx) => (
                            <div key={idx} style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                                <div style={labelStyle}>{label}</div>

                                {label === "Total" ? (
                                    <FormControl
                                        style={{ ...inputStyle, backgroundColor: "#E8F0FF" }}
                                        readOnly
                                        value={values.total}
                                    />
                                ) : (
                                    <FormControl
                                        type="number"
                                        style={inputStyle}
                                        value={values[fieldMap[label]] ?? ""}
                                        onChange={(e) => handleChange(fieldMap[label], e.target.value)}
                                    />
                                )}
                            </div>
                        )
                    )}
                </div>

                <div>
                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelStyle}>Non fragmented</div>
                        <FormControl
                            style={{ ...inputStyle, backgroundColor: "#E8F0FF" }}
                            readOnly
                            value={values.non_fragmented}
                        />
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelStyle}>Fragmented</div>
                        <FormControl
                            style={{ ...inputStyle, backgroundColor: "#E8F0FF" }}
                            readOnly
                            value={values.fragmented}
                        />
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px", marginTop: "20px" }}>
                        <div style={labelStyle}>DFI (%)</div>
                        <FormControl
                            style={{ ...inputStyle, backgroundColor: "#E8F0FF" }}
                            readOnly
                            value={values.DNA_index}
                        />
                    </div>
                </div>


            </div>


            <Row className="mt-4">
                <Col xs={12}>
                    <table className="table table-bordered table-responsive table-striped">
                        <thead>
                            <tr style={{ backgroundColor: "#DFF5F1", fontWeight: "bold" }}>
                                <th style={{ backgroundColor: "#DFF5F1" }}>Sr.No</th>
                                <th style={{ backgroundColor: "#DFF5F1" }}>Document Name</th>
                                <th style={{ backgroundColor: "#DFF5F1" }}>Upload Document</th>
                                <th style={{ backgroundColor: "#DFF5F1" }}>
                                    <Button variant="primary" size="md" onClick={addRow}>
                                        +
                                    </Button>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {documents.map((doc, index) => (
                                <tr key={doc.id}>
                                    <td>{index + 1}</td>

                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={doc.name}
                                            onChange={(e) =>
                                                handleNameChange(doc.id, e.target.value)
                                            }
                                            placeholder="Enter document name" readOnly
                                        />
                                    </td>

                                    {/* <td>
                                        <Form.Control
                                            type="file"
                                            accept=".jpg,.jpeg,.png,.pdf,.svg"
                                            onChange={(e) =>
                                                handleFileChange(doc.id, e.target.files[0])
                                            }
                                        />
                                        <h1>view doc</h1>
                                    </td> */}
                                    <td>
                                        <Form.Control
                                            type="file"
                                            accept=".jpg,.jpeg,.png,.pdf,.svg"
                                            onChange={(e) =>
                                                handleFileChange(doc.id, e.target.files[0])
                                            }
                                        />

                                        {/* View document if already uploaded */}
                                        {doc.existing && doc.file_path && (
                                            <div style={{ marginTop: "5px" }}>
                                                <a
                                                    href={`${API_URL}/documents/${doc.file_path.split('/').pop()}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ marginLeft: "10px", fontWeight: "500", color: "#007bff", textDecoration: "underline" }}
                                                >
                                                    View File
                                                </a>
                                            </div>
                                        )}
                                    </td>

                                    <td className="text-center">
                                        <Button
                                            variant="danger"
                                            size="md"
                                            onClick={() => openPasswordModal(doc.id)}
                                        >
                                            -
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Col>
            </Row>
            <div className="mb-3">
                <FormControl
                    as="textarea"
                    rows={2}
                    placeholder="Enter remarks here"
                    value={values.remark || ""}
                    onChange={(e) => handleChange("remark", e.target.value)}
                    style={{ width: "1000px", marginTop: "30px" }}
                />
            </div>
            <div className="d-flex justify-content-center mt-4">
                <Button
                    type="submit"
                    variant="primary"
                    className="px-4 mb-4"
                    onClick={handleSave}
                >
                    Save
                </Button>
            </div>



            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                backdrop="static"
                keyboard={false}
                dialogClassName="soft-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                        Confirm Password
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                            Enter your password
                        </Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="" autoComplete="off"
                            style={{
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                                padding: "10px 15px",
                                fontSize: "0.95rem",
                                boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                            }}
                        />
                    </Form.Group>
                    {error && (
                        <p
                            className="text-danger mt-2"
                            style={{ fontSize: "0.9rem", fontWeight: 500 }}
                        >
                            {error}
                        </p>
                    )}
                </Modal.Body>

                <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowModal(false)}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 18px",
                            fontWeight: 500,
                            boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={verifyPassword}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 20px",
                            fontWeight: 600,
                            background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                            border: "none",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                    >
                        Verify
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default DFIDataSCDKit;